import MotionWrapper from '../../../containers/MotionWrapper';
import LegalContainer from '../../../containers/Legal';
import styles from './style.module.scss';

export default function Legal() {
    return (
        <MotionWrapper className={styles.container}>
            <LegalContainer />
        </MotionWrapper>
    );
};
